import { render, staticRenderFns } from "./ReservationsNew.vue?vue&type=template&id=5a5e9893&scoped=true"
import script from "./ReservationsNew.vue?vue&type=script&lang=js"
export * from "./ReservationsNew.vue?vue&type=script&lang=js"
import style0 from "./ReservationsNew.vue?vue&type=style&index=0&id=5a5e9893&prod&module=true&scoped=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5a5e9893",
  null
  
)

export default component.exports